/* v26 (idea 3): the savings calculator works the answer out again as the visitor types (sections/dex-savings.liquid).
   Same sums as Dex's Value report: technician time per problem = hands-on + travel; money = (technician time minus
   the admin's minutes to approve) at the technician's rate, plus the staff's waiting time at the staff rate.
   v28: the currency switch (radios named "currency", data-sign and data-rate = one unit's worth in the first
   currency). The two hourly costs are kept in the first currency, so switching converts them and back again exactly;
   what the visitor types counts in the currency shown. The choice is remembered for their next visit.
   v28 (owner: "make the rates update automatically every day"): when a visitor picks a currency other than GEL, the
   day's official rates come from the National Bank of Georgia (no cookies or page address sent; kept in this browser
   for 6 hours) and replace the theme's rates, which stand when NBG cannot be reached. */
(function () {
  document.querySelectorAll('[data-dex-calc]').forEach(function (root) {
    var d = root.dataset;
    var num = function (k) { var v = parseFloat(d[k]); return isFinite(v) ? v : 0; };
    // Georgian groups thousands with a space (1 330); not every browser carries Georgian number data, so it is done here.
    var en = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
    var fmt = { format: function (v) { var s = en.format(v); return d.lang === 'ka' ? s.replace(/,/g, ' ') : s; } };
    var cur = { sign: d.currency, rate: 1, code: null };
    var pick = root.querySelector('input[name="currency"]:checked');
    if (pick) cur = { sign: pick.getAttribute('data-sign'), rate: parseFloat(pick.getAttribute('data-rate')) || 1, code: pick.value };
    var money = function (v) { return d.after === 'true' ? fmt.format(v) + ' ' + cur.sign : cur.sign + fmt.format(v); };
    var val = function (name) { var el = root.querySelector('[name="' + name + '"]'); var v = parseFloat(el && el.value); return isFinite(v) && v > 0 ? v : 0; };
    var out = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    var plan = function (pcs) { return pcs <= 15 ? 'Starter' : pcs <= 50 ? 'Business' : pcs <= 150 ? 'Pro' : 'Enterprise'; };
    var run = function () {
      var problems = val('problems');
      var techMin = num('hands') + num('travel');
      var perProblem = (techMin - num('approve')) / 60 * val('tech') + num('response') / 60 * val('staff');
      out('money').textContent = money(Math.max(0, Math.round(problems * perProblem / 10) * 10));
      out('hours').textContent = fmt.format(Math.round(problems * techMin / 60));
      if (out('plan')) out('plan').textContent = plan(val('pcs'));
    };
    // The hourly costs in the first currency.
    var base = { tech: val('tech') * cur.rate, staff: val('staff') * cur.rate };
    root.addEventListener('input', function (e) {
      var n = e.target && e.target.name;
      if (n === 'currency') return;
      if (n === 'tech' || n === 'staff') base[n] = val(n) * cur.rate;
      run();
    });
    var choose = function (r, remember) {
      cur = { sign: r.getAttribute('data-sign'), rate: parseFloat(r.getAttribute('data-rate')) || 1, code: r.value };
      ['tech', 'staff'].forEach(function (n) {
        var el = root.querySelector('[name="' + n + '"]');
        if (el && base[n] > 0) el.value = String(Math.max(1, Math.round(base[n] / cur.rate)));
      });
      root.querySelectorAll('.dex-calc__sign').forEach(function (s) { s.textContent = cur.sign; });
      if (remember) { try { window.localStorage.setItem('dexCalcCurrency', cur.code); } catch (err) { /* private window */ } }
      run();
    };
    var opts = Array.prototype.slice.call(root.querySelectorAll('input[name="currency"]'));
    var live = d.ratesLive === 'true' && opts.length > 1 && opts[0].value === 'GEL' && typeof window.fetch === 'function';
    var fetched = false;
    var applyRates = function (fx) {
      var sign = opts[0].getAttribute('data-sign');
      opts.slice(1).forEach(function (o) {
        var r = fx.rates[o.value];
        if (r > 0) { o.setAttribute('data-rate', String(r)); o.parentNode.title = '1 ' + o.value + ' = ' + sign + r.toFixed(4) + ' (NBG ' + fx.date + ')'; }
      });
      var on = root.querySelector('input[name="currency"]:checked');
      if (on && on !== opts[0]) choose(on, false);
    };
    var liveRates = function () {
      if (!live || fetched) return;
      fetched = true;
      var cached = null;
      try { cached = JSON.parse(window.localStorage.getItem('dexFx') || 'null'); } catch (err) { cached = null; }
      if (cached && cached.rates && cached.at && Date.now() - cached.at < 6 * 3600 * 1000) { applyRates(cached); return; }
      var codes = opts.slice(1).map(function (o) { return 'currencies=' + encodeURIComponent(o.value); }).join('&');
      // NBG now and then answers with an empty list: one more try two seconds later, and if that fails too, the next
      // currency switch tries again. Meanwhile the theme's rates stand.
      var attempt = function (left) {
        var ctl = window.AbortController ? new AbortController() : null;
        var timer = ctl ? setTimeout(function () { ctl.abort(); }, 6000) : null;
        window.fetch('https://nbg.gov.ge/gw/api/ct/monetarypolicy/currencies/en/json/?' + codes,
          { credentials: 'omit', referrerPolicy: 'no-referrer', signal: ctl ? ctl.signal : undefined })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (j) {
            var day = j && j[0];
            var fx = { date: String((day && day.date) || '').slice(0, 10), at: Date.now(), rates: {} };
            ((day && day.currencies) || []).forEach(function (c) { var q = parseFloat(c.quantity) || 1; var r = parseFloat(c.rate); if (r > 0) fx.rates[c.code] = r / q; });
            if (!Object.keys(fx.rates).length) throw new Error('no rates');
            try { window.localStorage.setItem('dexFx', JSON.stringify(fx)); } catch (err) { /* private window */ }
            applyRates(fx);
          })
          .catch(function () { if (left > 0) setTimeout(function () { attempt(left - 1); }, 2000); else fetched = false; })
          .then(function () { if (timer) clearTimeout(timer); });
      };
      attempt(1);
    };
    opts.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { choose(r, true); if (r !== opts[0]) liveRates(); } });
    });
    var saved = null;
    try { saved = window.localStorage.getItem('dexCalcCurrency'); } catch (err) { /* private window */ }
    var again = saved && root.querySelector('input[name="currency"][value="' + saved.replace(/[^A-Z]/gi, '') + '"]');
    if (again && !again.checked) { again.checked = true; choose(again, false); liveRates(); }
    run();
  });
})();
